import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "w-full h-full",
  viewBox: "0 0 17 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "m12.167 1.834.412.823c.176.354.265.531.383.685q.158.205.363.363c.154.118.33.206.685.383l.823.412-.823.412c-.354.177-.531.266-.685.384a2 2 0 0 0-.363.363c-.118.153-.207.33-.383.684l-.412.824-.412-.824c-.177-.354-.266-.53-.384-.684a2 2 0 0 0-.363-.363c-.153-.118-.33-.207-.684-.384L9.5 4.5l.824-.412c.354-.177.53-.265.684-.383a2 2 0 0 0 .363-.363c.118-.154.207-.33.384-.685zM14.167 9.426A5.078 5.078 0 1 1 7.24 2.5a6.348 6.348 0 1 0 6.926 6.926"
    }, null, -1)
  ])))
}
export default { render: render }